'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _ConfirmStores = require('./ConfirmStores');

var _ConfirmStores2 = _interopRequireDefault(_ConfirmStores);

var _ConfirmTerms = require('./ConfirmTerms');

var _ConfirmTerms2 = _interopRequireDefault(_ConfirmTerms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Import = function (_React$Component) {
	_inherits(Import, _React$Component);

	function Import(props) {
		_classCallCheck(this, Import);

		var _this = _possibleConstructorReturn(this, (Import.__proto__ || Object.getPrototypeOf(Import)).call(this, props));

		_this.freshState = _this.freshState.bind(_this);

		_this.state = _this.freshState();

		_this.renderFileError = _this._renderFileError.bind(_this);
		_this.renderConfirmation = _this._renderConfirmation.bind(_this);
		_this.renderImported = _this._renderImported.bind(_this);
		_this.renderErrors = _this._renderErrors.bind(_this);
		_this.submitImport = _this._submitImport.bind(_this);
		_this.parseResponse = _this._parseResponse.bind(_this);
		_this.onDrop = _this._onDrop.bind(_this);
		_this.handleConfirmStoresDone = _this._handleConfirmStoresDone.bind(_this);
		_this.hasErrors = _this._hasErrors.bind(_this);
		_this.reset = _this._reset.bind(_this);
		return _this;
	}

	_createClass(Import, [{
		key: 'freshState',
		value: function freshState() {
			return {
				stage: 'init',
				uploading: false,
				multiple: false,
				file: false,
				rejectedFiles: false,
				submitting: false,
				errors: this.emptyErrorsObject()
			};
		}
	}, {
		key: 'emptyErrorsObject',
		value: function emptyErrorsObject() {
			return {
				missing: {
					columns: [],
					stores: [],
					// stores: ['abc', 'cdef', 'hjk'],
					payment_terms: []
				}
			};
		}
	}, {
		key: 'render',
		value: function render() {
			// return <div className="import">
			// 	<ConfirmTerms />	
			// </div>

			return _react2.default.createElement(
				'div',
				{ className: 'import' },
				this.renderDropzone(),
				this.renderConfirmation(),
				this.renderImported(),
				this.renderErrors()
			);
		}
	}, {
		key: 'renderDropzone',
		value: function renderDropzone() {

			if (this.state.stage != 'init') return null;

			return _react2.default.createElement(
				_reactDropzone2.default,
				{
					className: 'dropzone',
					onDrop: this.onDrop,
					accept: '.csv'
				},
				_react2.default.createElement(
					'div',
					{ className: 'instructions' },
					_react2.default.createElement(
						'div',
						{ className: 'icon' },
						_react2.default.createElement('i', { className: 'ri-upload' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'text' },
						'Drag CSV file here or click to select a file.'
					),
					this.renderFileError()
				)
			);
		}
	}, {
		key: '_renderFileError',
		value: function _renderFileError() {

			if (!this.state.rejectedFiles || this.state.rejectedFiles.length == 0) return null;

			return _react2.default.createElement(
				'div',
				{ className: 'file-error' },
				_react2.default.createElement(
					'div',
					{ className: 'icon' },
					_react2.default.createElement('i', { className: 'ri-exclaim-document' })
				),
				'File not supported. Please upload a CSV file.'
			);
		}
	}, {
		key: '_renderErrors',
		value: function _renderErrors() {

			if (this.state.stage !== 'errors') return null;

			if (this.state.errors.missing && this.state.errors.missing.columns && this.state.errors.missing.columns.length) {
				return _react2.default.createElement(
					'div',
					{ className: 'file-error' },
					_react2.default.createElement(
						'div',
						{ className: 'icon' },
						_react2.default.createElement('i', { className: 'ri-exclaim-document' })
					),
					'We were not able to find the following columns: ',
					this.state.errors.missing.columns.join(', '),
					_react2.default.createElement('br', null),
					'Please check your file and try again. ',
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'div',
						{ className: 'btn', onClick: this.reset },
						'Restart'
					)
				);
			}

			if (this.state.errors.invalid && this.state.errors.invalid.seasons && this.state.errors.invalid.seasons.length) {
				return _react2.default.createElement(
					'div',
					{ className: 'file-error' },
					_react2.default.createElement(
						'div',
						{ className: 'icon' },
						_react2.default.createElement('i', { className: 'ri-exclaim-document' })
					),
					'Invalid seasons found: ',
					this.state.errors.invalid.seasons.join(', '),
					_react2.default.createElement('br', null),
					'Only PS, SS, PA, and AW are allowed and must use a two digital year. I.e. AW19. ',
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'div',
						{ className: 'btn', onClick: this.reset },
						'Restart'
					)
				);
			}

			if (this.state.errors.missing.stores.length) {
				return _react2.default.createElement(_ConfirmStores2.default, { onDone: this.handleConfirmStoresDone, stores: this.state.errors.missing.stores, reset: this.reset });
			}
			if (this.state.errors.missing.payment_terms.length) {
				return _react2.default.createElement(_ConfirmTerms2.default, { onDone: this.handleConfirmStoresDone, terms: this.state.errors.missing.payment_terms });
			}
		}
	}, {
		key: '_renderImported',
		value: function _renderImported() {
			if (this.state.stage !== 'completed') return null;

			return _react2.default.createElement(
				'div',
				{ className: 'xy-center done' },
				_react2.default.createElement('i', { className: 'ri-check-o' }),
				' ',
				_react2.default.createElement('br', null),
				'Import Completed. ',
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'a',
					{ href: '/data/orders' },
					'Click here'
				),
				' to go to orders.'
			);
		}
	}, {
		key: '_renderConfirmation',
		value: function _renderConfirmation() {

			if (this.state.stage != 'confirmation') return null;

			var submitting = this.state.submitting;
			var _state$data = this.state.data,
			    value = _state$data.value,
			    brands = _state$data.brands,
			    stores = _state$data.stores,
			    units = _state$data.units,
			    seasons = _state$data.seasons,
			    orderCount = _state$data.orderCount;


			return _react2.default.createElement(
				'div',
				{ className: 'confirmation-screen' },
				_react2.default.createElement(
					'h2',
					null,
					_react2.default.createElement(
						'div',
						{ onClick: this.submitImport, className: 'pull-right btn btn-success' },
						submitting ? 'Submitting...' : 'Submit'
					),
					orderCount,
					' Orders ready to import'
				),
				_react2.default.createElement(
					'div',
					{ className: 'data-items' },
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Value'
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content lg' },
							value.total
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Units'
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content lg' },
							units
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Currency Breakdown'
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content currency' },
							value.GBP,
							_react2.default.createElement('br', null),
							value.EUR,
							_react2.default.createElement('br', null),
							value.USD,
							_react2.default.createElement('br', null)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Stores'
						),
						_react2.default.createElement(
							'div',
							{ className: 'sub-title' },
							stores.length
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content' },
							this.diContentMapper(stores)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Brands'
						),
						_react2.default.createElement(
							'div',
							{ className: 'sub-title' },
							brands.length
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content' },
							this.diContentMapper(brands)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'data-item' },
						_react2.default.createElement(
							'div',
							{ className: 'title' },
							'Seasons'
						),
						_react2.default.createElement(
							'div',
							{ className: 'sub-title' },
							seasons.length
						),
						_react2.default.createElement(
							'div',
							{ className: 'di-content' },
							this.diContentMapper(seasons)
						)
					)
				)
			);
		}
	}, {
		key: 'diContentMapper',
		value: function diContentMapper(items) {

			if (!items[0] || !items[0].name) {
				return items.map(function (item) {
					return _react2.default.createElement(
						'div',
						{ className: 'di-content-item', key: item },
						item
					);
				});
			}

			return items.map(function (item) {
				return _react2.default.createElement(
					'div',
					{ className: 'di-content-item', key: item.slug },
					item.name
				);
			});
		}
	}, {
		key: '_onDrop',
		value: function _onDrop(acceptedFiles, rejectedFiles) {

			this.uploadFile(acceptedFiles[0]);

			if (rejectedFiles) {
				this.setState({
					rejectedFiles: rejectedFiles
				});
			}
		}
	}, {
		key: 'uploadFile',
		value: function uploadFile(file) {
			var _this2 = this;

			this.setState({
				errors: this.emptyErrorsObject()
			});

			var url = "/ajax/import";
			var data = new FormData();
			data.append('file', file);

			fetch(url, {
				credentials: 'same-origin',
				method: 'POST',
				headers: new Headers({
					'Accept': 'application/json',
					'X-CSRF-TOKEN': CSRF_TOKEN
				}),
				body: data
			}).then(function (response) {
				return response.json();
			}).then(function (data) {
				_this2.parseResponse(data);
			});
		}
	}, {
		key: '_submitImport',
		value: function _submitImport() {
			var _this3 = this;

			if (this.state.submitting) return;

			this.setState({
				submitting: true,
				errors: this.emptyErrorsObject()
			});

			var url = "/ajax/import/submit";
			fetch(url, {
				credentials: 'same-origin',
				method: 'POST',
				headers: new Headers({
					'Accept': 'application/json',
					'X-CSRF-TOKEN': CSRF_TOKEN
				}),
				body: ''
			}).then(function (response) {
				return response.json();
			}).then(function (data) {
				_this3.parseResponse(data);
			});
		}
	}, {
		key: '_parseResponse',
		value: function _parseResponse(data) {

			var hasErrors = this.hasErrors(data);

			this.setState({
				stage: hasErrors ? 'errors' : data.stage,
				data: data,
				errors: data.errors
			});
		}
	}, {
		key: '_hasErrors',
		value: function _hasErrors(data) {

			var data = typeof data === 'undefined' ? this.state : data;

			var hasErrors = false;

			if (data.errors && data.errors.missing && data.errors.missing.stores && data.errors.missing.stores.length) {
				hasErrors = true;
			}

			if (data.errors && data.errors.missing && data.errors.missing.payment_terms && data.errors.missing.payment_terms.length) {
				hasErrors = true;
			}

			if (data.errors && data.errors.missing && data.errors.missing.columns && data.errors.missing.columns.length) {
				hasErrors = true;
			}

			if (data.errors && data.errors.invalid && data.errors.invalid.seasons && data.errors.invalid.seasons.length) {
				hasErrors = true;
			}

			return hasErrors;
		}
	}, {
		key: '_handleConfirmStoresDone',
		value: function _handleConfirmStoresDone() {
			var _this4 = this;

			var url = location.origin + '/ajax/import/status';

			fetch(url, {
				credentials: 'same-origin',
				method: 'GET',
				headers: new Headers({
					'Accept': 'application/json'
				})
			}).then(function (response) {
				return response.json();
			}).then(function (data) {
				_this4.parseResponse(data);
			});
		}
	}, {
		key: '_reset',
		value: function _reset() {
			this.setState(this.freshState());
		}
	}]);

	return Import;
}(_react2.default.Component);

exports.default = Import;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/data/Import.js
// module id = 513
// module chunks = 0